module.exports = "/img/s2o_bg.jpg?9a0bcb213446fc22f6a65b4bfe731c70";